import * as d3 from 'd3';
import theme from '../../theme';

// ATR's ~$0.50-3 range is meaningless plotted against a $50-300 price
// y-domain -- this is why it silently rendered as a flat, useless line
// before this rebuild (it used to be classified as an "overlay"). Drawn in
// its own subchart pane instead, filled-area style like a volatility strip.
export const drawATR = (svg, data, xScale, yScale, values, color = theme.indicators.atr) => {
    if (!values || !Array.isArray(values)) return;

    const validPoints = values
        .map((value, i) => ({ x: new Date(data[i]?.start_date), y: value }))
        .filter((d) => !isNaN(d.y) && d.y !== null);
    if (validPoints.length === 0) return;

    const areaGen = d3
        .area()
        .x((d) => xScale(d.x))
        .y0(yScale.range()[0])
        .y1((d) => yScale(d.y))
        .curve(d3.curveMonotoneX);

    svg.append('path').datum(validPoints).attr('fill', color).attr('opacity', 0.18).attr('d', areaGen);

    const lineGen = d3
        .line()
        .x((d) => xScale(d.x))
        .y((d) => yScale(d.y))
        .curve(d3.curveMonotoneX);

    svg.append('path').datum(validPoints).attr('fill', 'none').attr('stroke', color).attr('stroke-width', 1.5).attr('d', lineGen);
};
